// extracted by mini-css-extract-plugin
module.exports = {"transactions":"ActivityTransactions_transactions__fz-7K"};